export const getBase64 = (file) => {
  return new Promise((resolve) => {
    let baseURL = "";
    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};

export function NumbersAndSpecialCharactersRegex(str) {
  return /[^A-Z a-z]/.test(str);
}
export function NumbersRegex(str) {
  return /[^0-9]/.test(str);
}

export const relationwithApplicant = [{
  key: "Father",
  value: "Father"
},
{
  key: "Mother",
  value: "Mother"
},
{
  key: "Spouse",
  value: "Spouse"
},
{
  key: "Children (13+)",
  value: "Children (13+)"
},
{
  key: "Friend",
  value: "Friend"
},
{
  key: "Others",
  value: "Others"
}]
export const cardlimitpercent = [
  {
    key: "10%",
    value: "10%"
  },
  {
    key: "25%",
    value: "25%"
  },
  {
    key: "50%",
    value: "50%"
  },
  {
    key: "75%",
    value: "75%"
  },
  {
    key: "100%",
    value: "100%"
  }
]